export const APP_NAME = 'Fomeje';

export const ROLES = {
  SUPER_ADMIN: 'superAdmin',
  ADMIN: 'admin',
  EDITOR: 'editor',
  USER: 'user',
  MEMBER: 'member'
};

export const STORAGE_PATHS = {
  PROFILE_IMAGES: 'profile-images',
  PUBLICATIONS: 'publications',
  EVENT_IMAGES: 'event-images',
  ACTIVITY_IMAGES: 'activity-images',
  MEMBERS: 'members',
  PROJECTS: 'projects'
};

export const COLLECTIONS = {
  USERS: 'users',
  EVENTS: 'events',
  PUBLICATIONS: 'publications',
  GROUPS: 'groups',
  CLUBS: 'clubs',
  ACTIVITIES: 'activities'
};

export const ERROR_MESSAGES = {
  AUTH: {
    INVALID_EMAIL: 'Invalid email address',
    WEAK_PASSWORD: 'Password should be at least 6 characters',
    EMAIL_IN_USE: 'Email already in use',
    INVALID_CREDENTIALS: 'Invalid email or password'
  },
  GENERAL: {
    SOMETHING_WENT_WRONG: 'Something went wrong. Please try again.',
    UNAUTHORIZED: 'You are not authorized to perform this action',
    NOT_FOUND: 'Resource not found'
  }
};

export const BREAKPOINTS = {
  xs: '320px',
  sm: '640px',
  md: '768px',
  lg: '1024px',
  xl: '1280px'
}; 